import {
  Box,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

/* JOB LIST */
const jobs = [
  {
    title: "Draughtsman",
    description:
      "Prepare fabrication drawings, GA drawings and support engineering teams.",
  },
  {
    title: "Estimation Engineer",
    description:
      "Prepare techno-commercial offers, costing and system estimation.",
  },
  {
    title: "Manager Marketing",
    description:
      "Lead and execute marketing strategies to strengthen brand presence and drive business growth.",
  },
];

export default function JobOpeningsPage() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    location: "",
    resume: null,
  });

  const handleOpen = (jobTitle) => {
    setSelectedJob(jobTitle);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setForm({ name: "", email: "", location: "", resume: null });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = () => {
    alert("Application submitted successfully!");
    handleClose();
  };

  return (
    <Box
      component="section"                      // ✅ semantic
      sx={{
        px: { xs: 2, sm: 4, md: "250px" },
        py: 10,
        fontFamily: "Roboto, sans-serif",      // ✅ Roboto everywhere
      }}
    >
      {/* ===== PAGE TITLE ===== */}
      <Typography
        component="h1"                         // ✅ semantic h1
        sx={{
          fontSize: "32px",                    // ✅ exact
          fontWeight: 700,
          color: "#2d2075",
          lineHeight: 1.5,
          mb: 5,
          textAlign: "center",
        }}
      >
        Job Openings
      </Typography>

      {/* ===== JOB LIST ===== */}
      <Box component="article">
        {jobs.map((job, i) => (
          <Paper
            key={i}
            elevation={2}
            sx={{
              p: 4,
              mb: 3,
              borderRadius: "2px",
              backgroundColor: "#fff",
            }}
          >
            <Typography
              component="h2"                   // ✅ SEO heading
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                color: "#06224A",
                lineHeight: 1.5,
                mb: 1,
              }}
            >
              {job.title}
            </Typography>

            <Typography
              component="p"
              sx={{
                fontSize: "20px",               // ✅ paragraph size
                color: "#444",
                lineHeight: 1.5,
                mb: 3,
              }}
            >
              {job.description}
            </Typography>

            <Button
              aria-label={`Apply for ${job.title}`}  // ✅ accessibility
              variant="outlined"
              onClick={() => handleOpen(job.title)}
              sx={{
                borderColor: "#2d2075",
                color: "#2d2075",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#2d2075",
                  color: "#fff",
                },
              }}
            >
              Apply Now
            </Button>
          </Paper>
        ))}
      </Box>

      {/* ===== BACK BUTTON ===== */}
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Button
          aria-label="Back to career section"
          onClick={() => navigate("/", { state: { scrollTo: "career" } })}
          sx={{
            backgroundColor: "#2d2075",
            color: "#fff",
            px: 4,
            py: 1.5,
            fontSize: "16px",
            fontWeight: 600,
            borderRadius: "2px",
            textTransform: "none",
            "&:hover": { backgroundColor: "#083168" },
          }}
        >
          ← Back to Career
        </Button>
      </Box>

      {/* ===== APPLY FORM DIALOG ===== */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            fontWeight: 700,
            color: "#2d2075",
            fontFamily: "Roboto, sans-serif",
          }}
        >
          Apply for {selectedJob}
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            label="Full Name"
            name="name"
            fullWidth
            sx={{ mb: 2 }}
            value={form.name}
            onChange={handleChange}
          />

          <TextField
            label="Email"
            name="email"
            fullWidth
            sx={{ mb: 2 }}
            value={form.email}
            onChange={handleChange}
          />

          <TextField
            label="Location"
            name="location"
            fullWidth
            sx={{ mb: 3 }}
            value={form.location}
            onChange={handleChange}
          />

          <Typography
            component="p"
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Upload Resume (PDF / DOC)
          </Typography>

          <input
            type="file"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
          />
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose}>Cancel</Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: "#2d2075",
              "&:hover": { backgroundColor: "#2d2075" },
            }}
          >
            Submit Application
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
